import type { ColDef } from '@ag-grid-community/core';
import type { AggregateReportConfig, ReportData } from '../report-viewer/report-viewer.model';

/**
 * Column Definitions for Storage by OU Report
 */
export const STORAGE_BY_OU_COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'High Storage',
    field: 'highStorage',
    width: 150,
    cellClass: 'text-center',
    headerClass: 'text-center storage-high-header',
  },
  {
    headerName: 'Moderate Storage',
    field: 'moderateStorage',
    width: 150,
    cellClass: 'text-center',
    headerClass: 'text-center storage-moderate-header',
  },
  {
    headerName: 'Low Storage',
    field: 'lowStorage',
    width: 150,
    cellClass: 'text-center',
    headerClass: 'text-center storage-low-header',
  },
  {
    headerName: 'Critical Storage',
    field: 'criticalStorage',
    width: 150,
    cellClass: 'text-center',
    headerClass: 'text-center storage-critical-header',
  },
  {
    headerName: 'Unknown',
    field: 'unknown',
    width: 150,
    cellClass: 'text-center',
    headerClass: 'text-center storage-unknown-header',
  },
];

/**
 * Configuration for Storage by OU aggregate report
 */
export function createStorageByOuReportConfig(data: unknown[]): ReportData {
  const aggregateConfig: AggregateReportConfig = {
    columns: STORAGE_BY_OU_COLUMN_DEFS,
    groupFields: ['ouPath'],
    aggregationField: 'highStorage', // Used for tree grouping, actual values come from individual fields
    autoGroupColumnName: 'OU Path',
    data,
  };

  return {
    type: 'storage-by-ou',
    data,
    aggregateConfig,
  };
}
